// extracted by mini-css-extract-plugin
export default {"formInput":"Form_formInput__egWXp","formButton":"Form_formButton__DcIOs","form":"Form_form__mWe+i"};